<script setup lang="ts">
const props = defineProps({
  to: {
    type: [String, Object],
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
  trackEvent: {
    type: Function,
    default: null,
  },
  trackComponent: {
    type: String,
    default: '',
  },
  className: {
    type: String,
    default: '',
  },
})

const localePath = useLocalePath()

function handleClick() {
  if (typeof props.trackEvent === 'function')
    props.trackEvent()
}
</script>

<template>
  <nuxt-link :to="localePath(to)" custom>
    <template #default="{ href }">
      <a
        v-check-login="href"
        :href="href"
        :class="className"
        :title="title"
        :track-component="trackComponent"
        @click="handleClick"
      >
        <slot />
      </a>
    </template>
  </nuxt-link>
</template>
